// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 15C7.52369 15 8.81916 15.9739 9.2998 17.333C10.0061 17.0244 10.5 16.3201 10.5 15.5L10.5 8.5C10.5 6.29086 12.2909 4.5 14.5 4.5H14.6455C15.0758 3.05434 16.4145 2 18 2C19.933 2 21.5 3.567 21.5 5.5C21.5 7.433 19.933 9 18 9C16.4145 9 15.0758 7.94567 14.6455 6.5H14.5C13.3954 6.5 12.5 7.39543 12.5 8.5L12.5 15.5C12.5 17.4061 11.1666 18.9997 9.38184 19.4014C8.98412 20.8974 7.62126 22 6 22C4.067 22 2.5 20.433 2.5 18.5C2.5 16.567 4.067 15 6 15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.9551 17.0439L23.1797 18.5L19.9551 19.9551L18.5 23.1797L17.0439 19.9551L13.8203 18.5L17.0439 17.0439L18.5 13.8203L19.9551 17.0439Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.07812 3.92188L8.24414 5L6.07812 6.07812L5 8.24414L3.92188 6.07812L1.75586 5L3.92188 3.92188L5 1.75586L6.07812 3.92188Z"}}]};

const AiGitBranchFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ai-git-branch-filled',
    ref,
    icon: element,
  },
));

AiGitBranchFilledIcon.displayName = 'AiGitBranchFilledIcon';

export default AiGitBranchFilledIcon;
